import React, { Component } from "react";
import { Alert, Button } from "react-bootstrap";
import { FaQuestionCircle } from "react-icons/fa";
import { postJob } from "../../../Redux/Jobs/Action";
import { connect } from "react-redux";

import PostJobForm from "./PostJobForm";
import PaymentWall from "./PaymentWall";

class PostJob extends Component {
  state = {
    paymentVerified: null, // null = checking, true = verified, false = not verified
    showHelp: false,
  };

  handlePaymentVerification = (isVerified) => {
    this.setState({ paymentVerified: isVerified });
  };

  render() {
    const { paymentVerified } = this.state;

    // Still checking payment status
    if (paymentVerified === null) {
      return <PaymentWall onPaymentVerified={this.handlePaymentVerification} />;
    }

    // Payment not verified - show payment wall
    if (!paymentVerified) {
      return <PaymentWall onPaymentVerified={this.handlePaymentVerification} />;
    }

    // Payment verified - show job posting form
    return (
      <div className="container p-0 post-job-container">
        <h1 className="page-title d-flex align-items-center">
          Post a Job
          <Button
            variant="link"
            className="p-0 ml-3 d-inline-flex align-items-center"
            onClick={() => this.setState({ showHelp: !this.state.showHelp })}
            title="About Job Postings"
          >
            <FaQuestionCircle size={24} className="text-info" />
            <span className="text-info ml-2" style={{ fontSize: '1rem', fontWeight: 'normal' }}>Help</span>
          </Button>
        </h1>
        {this.state.showHelp && (
          <Alert
            variant="info"
            className="my-4"
            dismissible
            onClose={() => this.setState({ showHelp: false })}
          >
            <Alert.Heading>About Job Postings</Alert.Heading>
            <p className="mb-0">
              Jobs posted on JobInfoNetwork will be available to jobseekers registered at JobInfoNetwork and sent to all job seekers who have requested job postings in their industry. Job postings will also be sent to all employed members, aka Support Team Members, who have requested job postings in their industry.
            </p>
          </Alert>
        )}
        <div className="dashboard-wrapper resumes-page">
          <PostJobForm />
        </div>
      </div>
    );
  }
}

export default connect(null, { postJob })(PostJob);
